module.exports = __webpack_public_path__ + "report.1d4d4ef06e833c8149202a23d801f3e7.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/menu/selected/report.svg
// module id = 144
// module chunks = 0